<mat-toolbar color="white" class="shadow-box ui-shadow-3 ah-toolbar" [ngClass]="{'ah-toolbar-dark': dark}" ngClass.xs="mobile-toolbar">
  <!-- Top Nav -->
  <mat-toolbar-row>
    @if (isMobile) {
      <div>
        <p-menubar [model]="items"></p-menubar>
      </div>
    }
    @if (!isMobile) {
      <div class="toolbar-sos-logo">
        <img src="/assets/images/sos-logo.png">
      </div>
    }
    <div class="flex justify-content-center center">
      @if (currentStudio) {
        <span class="toolbar-link text-headline" (click)="selectStudioFromMenu(currentStudio, false)"
        ngClass.xs="mobile-text-studio-name">{{currentStudio.name}}</span>
      } @else {
        <span class="text-headline">AssetHub</span>
      }
      @if (navType === NAV_TYPES.DIVISION) {
        <span class="toolbar-separating-arrow" ngClass.xs="mobile-toolbar-separating-arrow">
          <mat-icon svgIcon="chevron_right"></mat-icon>
        </span>
      }
      @if (navType === NAV_TYPES.DIVISION) {
        <span routerLink="/division/{{currentDivision?.id}}" class="toolbar-link text-headline franchise-name"
        ngClass.xs="mobile-text-headline">{{currentDivision?.name}}</span>
      }
      @if (navType === NAV_TYPES.FRANCHISE) {
        <span class="toolbar-separating-arrow" ngClass.xs="mobile-toolbar-separating-arrow">
          <mat-icon svgIcon="chevron_right"></mat-icon>
        </span>
      }
      @if (navType === NAV_TYPES.FRANCHISE) {
        <span routerLink="/franchise/{{currentFranchise?.id}}/assets" class="toolbar-link text-headline franchise-name"
        ngClass.xs="mobile-text-headline">{{currentFranchise?.name}}</span>
      }
    </div>
    <span class="toolbar-spacer"></span>
    @if (!user) {
      <button mat-raised-button (click)="loginFromSynconset()">Login</button>
    }
    <ah-toolbar-menu (lightSwitch)="lightSwitch()" [dark]="dark" (selectStudioFromMenu)="selectStudioFromMenu($event, true)"
    [currentStudio]="currentStudio" [studioList]="studioList"></ah-toolbar-menu>
  </mat-toolbar-row>
  <!-- Sub Nav -->
  @if (!isMobile) {
    <mat-toolbar-row>
      <p-menubar [model]="navSelectOptions"></p-menubar>
      <p-menubar [model]="items"></p-menubar>
    </mat-toolbar-row>
  }
</mat-toolbar>
